(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-warranty-label"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-eu-warranty]').forEach(function (root) {
    if (root.dataset.euwInit) return;
    root.dataset.euwInit = '1';

    root.querySelectorAll('[data-euw-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scrollX = window.scrollX;
        var scrollY = window.scrollY;
        var card = btn.closest('[data-euw-item]');
        var panel = card.querySelector('[data-euw-panel]');
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        function keepPosition() {
          window.scrollTo(scrollX, scrollY);
        }
        keepPosition();
        requestAnimationFrame(keepPosition);
        setTimeout(keepPosition, 60);
      });
    });

    var modal = root.querySelector('[data-euw-lightbox-modal]');
    var modalImg = modal && modal.querySelector('.euw__lightbox-img');
    var closeBtn = modal && modal.querySelector('[data-euw-lightbox-close]');
    if (modal) document.body.appendChild(modal);

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      if (modalImg) modalImg.src = '';
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-euw-lightbox]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!modal || !modalImg) return;
        modalImg.src = btn.getAttribute('data-euw-lightbox');
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
